import script from "./tag-edit-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-edit-dialog.vue?vue&type=script&setup=true&lang=js"

import "./tag-edit-dialog.vue?vue&type=style&index=0&id=6d92f51b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d92f51b"]])

export default __exports__